import { Box, Stack, Typography } from "@mui/material";

import LearnVisualFrame from "./LearnVisualFrame";

function StageColumn({ stage, resource, evidence }) {
  return (
    <Box sx={{ flex: 1, minWidth: 190, p: 1.7, border: "1px solid rgba(34,35,37,0.12)", borderRadius: 1, backgroundColor: "rgba(255,255,255,0.72)" }}>
      <Typography sx={{ fontSize: 12, fontWeight: 900, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0 }}>
        {stage}
      </Typography>
      <Typography sx={{ mt: 1, fontSize: 28, fontWeight: 900, color: "primary.main" }}>{resource}</Typography>
      <Typography sx={{ mt: 0.75, fontSize: 13.5, lineHeight: 1.45, fontWeight: 800 }}>
        {evidence}
      </Typography>
    </Box>
  );
}

export default function LifecycleResourceValuationVisual({ title, takeaway, caption, data = {} }) {
  const columns = data.columns || [
    { stage: "Exploration", resource: "1 Moz", evidence: "Geological evidence, high uncertainty about development and economics" },
    { stage: "Development", resource: "1 Moz", evidence: "Technical and economic evidence, funding and permitting still matter" },
    { stage: "Production", resource: "1 Moz", evidence: "Operating, reserve and production evidence shape durability" },
  ];

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} takeawaySx={{ mt: 2.1, mb: 0.4 }}>
      <Typography sx={{ mb: 2.2, textAlign: "center", fontSize: 13, fontWeight: 900, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0 }}>
        Same hypothetical resource scale
      </Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
        {columns.map((column) => (
          <StageColumn key={column.stage} {...column} />
        ))}
      </Stack>
    </LearnVisualFrame>
  );
}
